import {
  TypeAttribute,
  TypeMetric,
  TypeMetricKey,
  TypeMetricPercentile,
  TypeMetricUnit,
} from '@trace/types';

export const METRIC_PERCENTILE_DEFAULT: TypeMetricPercentile = 'p50';

export const METRIC_BY_KEY: Record<TypeMetricKey, TypeMetric> = {
  ApplicationCrash: 'app.crash.total',
  ApplicationError: 'app.error.total',
  CpuPct: 'process.cpu.pct',
  MemoryBytes: 'app.memory.bytes',
  NetworkError: 'app.request.total',
  NetworkRequestLatency: 'app.request.latency.ms',
  NetworkRequestSize: 'app.request.size.bytes',
  NetworkRequestTotal: 'app.request.total',
  NetworkResponseSize: 'app.response.size.bytes',
  RenderLatency: 'view.render.latency.ms',
  StartupLatencyCold: 'app.startup.latency.ms',
  StartupLatencyHot: 'app.startup.latency.ms',
};

export const METRIC_FILTERS_BY_KEY: Record<TypeMetricKey, [string, string][]> = {
  ApplicationCrash: [],
  ApplicationError: [],
  CpuPct: [],
  MemoryBytes: [['filter', 'memory.state:res']],
  NetworkError: [['filter', 'http.status_code:5xx']],
  NetworkRequestLatency: [],
  NetworkRequestSize: [],
  NetworkRequestTotal: [],
  NetworkResponseSize: [],
  RenderLatency: [],
  StartupLatencyCold: [['filter', 'app.start.state:cold']],
  StartupLatencyHot: [['filter', 'app.start.state:warm']],
};

export const METRIC_KEY_BY_NAME: { [key: string]: TypeMetricKey } = {
  'App Crash Rate': 'ApplicationCrash',
  'App Error Rate': 'ApplicationError',
  'CPU Usage': 'CpuPct',
  'Memory Usage': 'MemoryBytes',
  'Network Error Rate': 'NetworkError',
  'Network Request Latency': 'NetworkRequestLatency',
  'Network Request Size': 'NetworkRequestSize',
  'Network Request Count': 'NetworkRequestTotal',
  'Network Response Size': 'NetworkResponseSize',
  'Render Latency': 'RenderLatency',
  'Cold Start Latency': 'StartupLatencyCold',
  'Warm Start Latency': 'StartupLatencyHot',
};

export const METRICS_SESSION_ORDER: TypeMetricKey[] = ['CpuPct', 'MemoryBytes'];

export const METRIC_NAME_BY_KEY: Record<TypeMetricKey, string> = {
  ApplicationCrash: 'App Crash Rate',
  ApplicationError: 'App Error Rate',
  CpuPct: 'CPU Usage',
  MemoryBytes: 'Memory Usage',
  NetworkError: 'Network Error Rate',
  NetworkRequestLatency: 'Network Request Latency',
  NetworkRequestSize: 'Network Request Size',
  NetworkRequestTotal: 'Network Request Count',
  NetworkResponseSize: 'Network Response Size',
  RenderLatency: 'Render Latency',
  StartupLatencyCold: 'Cold Start Latency',
  StartupLatencyHot: 'Warm Start Latency',
};

export const METRIC_IS_COUNTER_BY_KEY: Record<TypeMetricKey, boolean> = {
  ApplicationCrash: true,
  ApplicationError: true,
  CpuPct: false,
  MemoryBytes: false,
  NetworkError: true,
  NetworkRequestLatency: false,
  NetworkRequestSize: false,
  NetworkRequestTotal: true,
  NetworkResponseSize: false,
  RenderLatency: false,
  StartupLatencyCold: false,
  StartupLatencyHot: false,
};

export const METRIC_UNIT_BY_KEY: Record<TypeMetricKey, TypeMetricUnit> = {
  ApplicationCrash: 'number/s',
  ApplicationError: 'number/s',
  CpuPct: 'percent',
  MemoryBytes: 'bytes',
  NetworkError: 'number/s',
  NetworkRequestLatency: 'ms',
  NetworkRequestSize: 'bytes',
  NetworkRequestTotal: 'number/s',
  NetworkResponseSize: 'bytes',
  RenderLatency: 'ms',
  StartupLatencyCold: 'ms',
  StartupLatencyHot: 'ms',
};

export const METRIC_PERCENTILES_ORDER: TypeMetricPercentile[] = ['p5', 'p50', 'p95'];

export const METRIC_PERCENTILES_NAME: Record<TypeMetricPercentile, string> = {
  p5: '5th Percentile',
  p50: 'Median',
  p95: '95th Percentile',
};

export const METRIC_UNIT_NAME: Record<TypeMetricUnit, string> = {
  1: 'Total',
  bytes: 'Bytes',
  ms: 'Duration',
  'number/s': 'Per second',
  percent: 'Percent',
  seconds: 'Duration',
};

export const METRIC_GROUPING_DEFAULTS: { [key in TypeMetricKey]: TypeAttribute } = {
  ApplicationCrash: 'app.version',
  ApplicationError: 'app.version',
  CpuPct: 'app.version',
  MemoryBytes: 'app.version',
  NetworkError: 'app.version',
  NetworkRequestLatency: 'app.version',
  NetworkRequestSize: 'app.version',
  NetworkRequestTotal: 'app.version',
  NetworkResponseSize: 'app.version',
  RenderLatency: 'app.version',
  StartupLatencyCold: 'app.version',
  StartupLatencyHot: 'app.version',
};
